import { Link } from "@tanstack/react-router";
import { ArrowRight, Zap } from "lucide-react";
import { useState } from "react";

export function ArticleCTA() {
  return (
    <aside className="my-10 overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-br from-primary/15 via-card to-card p-8 not-prose">
      <div className="flex items-start gap-4">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/20 text-primary">
          <Zap className="h-5 w-5" />
        </span>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-foreground">Un sito web professionale in 48 ore.</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Design premium, SEO inclusa e consegna garantita. Pacchetti a tariffa fissa da CHF 990.
          </p>
          <Link
            to="/"
            hash="price"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90"
          >
            Vedi i pacchetti
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </aside>
  );
}

export function NewsletterBox() {
  const [privacy, setPrivacy] = useState(false);
  return (
    <section className="rounded-2xl border border-border/60 bg-card/40 p-8">
      <h3 className="text-xl font-bold">Newsletter FlashWeb</h3>
      <p className="mt-2 text-sm text-muted-foreground">
        Una mail al mese con guide SEO, casi studio e tendenze sul web in Svizzera. Niente spam.
      </p>
      <form
        className="mt-4 space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          if (!privacy) return;
          const form = e.currentTarget;
          const email = (form.elements.namedItem("email") as HTMLInputElement).value;
          window.location.href = `mailto:info@flash-web.ch?subject=Iscrizione%20newsletter&body=Iscrivimi%20alla%20newsletter:%20${encodeURIComponent(email)}`;
        }}
      >
        <div className="flex flex-col gap-2 sm:flex-row">
          <input
            type="email"
            name="email"
            required
            placeholder="la-tua@email.ch"
            className="flex-1 rounded-full border border-border bg-background px-4 py-2.5 text-sm outline-none focus:border-primary"
          />
          <button
            type="submit"
            disabled={!privacy}
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground hover:opacity-90 disabled:opacity-50"
          >
            Iscrivimi
          </button>
        </div>
        <label className="flex items-start gap-2 text-xs text-muted-foreground">
          <input
            type="checkbox"
            required
            checked={privacy}
            onChange={(e) => setPrivacy(e.target.checked)}
            className="mt-0.5 h-4 w-4 shrink-0 rounded border-border accent-primary"
          />
          <span>
            Accetto la{" "}
            <Link to="/privacy-policy" className="text-primary underline hover:opacity-80">
              Privacy Policy
            </Link>{" "}
            e autorizzo il trattamento dei miei dati.
          </span>
        </label>
        <p className="text-[11px] text-muted-foreground">Nessuno spam. Puoi cancellarti in qualsiasi momento.</p>
      </form>
    </section>
  );
}
